import React from 'react';
import { StyledComponent } from '@emotion/styled';
import { layout, space } from 'styled-system';
import { styled, Text } from '@staffino/primitive-controls';

const Note: StyledComponent<React.ComponentProps<typeof Text>> = styled(Text)({
  size: 'small',
  color: '#a3b2bf',
  padding: '0 20px',
});

const Title: StyledComponent<React.ComponentProps<typeof Text>> = styled(Text)({
  size: 'large',
  color: '#1f263a',
  bold: true,
});

const SubTitle: StyledComponent<React.ComponentProps<typeof Text>> = styled(
  Text,
)({
  color: '#a3b2bf',
});

const Headline: StyledComponent<React.ComponentProps<typeof Text>> = styled(
  Text,
)(
  {
    color: '#1f263a',
    fontSize: '1.625rem',
    fontWeight: 'bold',
    lineHeight: 1.25,
    textAlign: 'center',
  },
  space,
  layout,
);

export { Title, SubTitle, Note, Text, Headline };
